// docs/116 CI5: the dice table's sounds. The inn's own banks (`inn.*`) are played when this build has
// them; until then each falls back to the nearest bank that exists, so the table is never silent.
// Variants are seeded (by the throw, the game) so every client in the room hears the same clatter.
import { playSfx, sfxVariantCount, type PlayOptions, type SfxKey } from '../../../../core/audio';
import { hashInts } from './dice';

export type InnSound =
  | 'inn.dice_throw' | 'inn.dice_one' | 'inn.dice_settle' | 'inn.chips' | 'inn.coins_pot' | 'inn.coins_win'
  | 'inn.coin_flip' | 'inn.turn' | 'inn.cheers' | 'inn.applause' | 'inn.gasp' | 'inn.groan' | 'inn.laugh' | 'inn.clink';

const FALLBACK: Record<InnSound, SfxKey> = {
  'inn.dice_throw': 'ui.dice',
  'inn.dice_one': 'ui.dice',
  'inn.dice_settle': 'ui.dice',
  'inn.chips': 'ui.coins',
  'inn.coins_pot': 'cue.coins',
  'inn.coins_win': 'ui.coins_big',
  'inn.coin_flip': 'ui.coins',
  'inn.turn': 'ui.tab',
  'inn.cheers': 'cue.crowd_cheer',
  'inn.applause': 'cue.crowd_cheer',
  'inn.gasp': 'cue.gasp',
  'inn.groan': 'emote.lament',
  'inn.laugh': 'emote.laughing',
  'inn.clink': 'ui.equip_trinket',
};

/** The bank this build plays for `s` (its own once bundled, else the stand-in). */
export function innKey(s: InnSound): SfxKey {
  const own = s as string as SfxKey;
  return sfxVariantCount(own) > 0 ? own : FALLBACK[s];
}

/** Plays `s` with a variant seeded by `seed` (the same on every client). */
export function playInn(s: InnSound, seed: number, opts: Omit<PlayOptions, 'variant'> = {}): boolean {
  const key = innKey(s);
  const n = sfxVariantCount(key);
  return playSfx(key, { ...opts, ...(n > 0 ? { variant: hashInts(seed, s.length) % n } : {}) });
}
